var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-layout-sider",
    {
      class: [
        "sider",
        _vm.isDesktop() ? null : "shadow",
        _vm.theme,
        _vm.fixSiderbar ? "ant-fixed-sidemenu" : null,
      ],
      attrs: { width: "200px", collapsible: _vm.collapsible, trigger: null },
      model: {
        value: _vm.collapsed,
        callback: function ($$v) {
          _vm.collapsed = $$v
        },
        expression: "collapsed",
      },
    },
    [
      _c("s-menu", {
        style: _vm.smenuStyle,
        attrs: {
          collapsed: _vm.collapsed,
          menu: _vm.menus,
          theme: _vm.theme,
          mode: _vm.mode,
        },
        on: { select: _vm.onSelect },
      }),
      _c(
        "div",
        {
          style: {
            height: "40px",
            "line-height": "40px",
            width: !_vm.collapsed ? "200px" : "80px",
            "text-align": "center",
            position: "fixed",
            bottom: "0",
            "z-index": "1",
            cursor: "pointer",
            "font-size": "20px",
            "border-top": "1px solid #e9e9e9",
            background: "white",
          },
          on: { click: _vm.toggle },
        },
        [
          !_vm.collapsed
            ? _c("a-icon", { attrs: { type: "left-circle" } })
            : _c("a-icon", { attrs: { type: "right-circle" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }